export const REQUIRED_MEMBERSHIP_DURATION = 120;
export const PERSONAL_ROOM_USER_LIMIT = 100;


// WEBPACK FOOTER //
// ./src/constants/mybobtv.js